import { render, staticRenderFns } from "./main-feature.vue?vue&type=template&id=92cfbc96&scoped=true&"
import script from "./main-feature.vue?vue&type=script&lang=js&"
export * from "./main-feature.vue?vue&type=script&lang=js&"
import style0 from "./main-feature.vue?vue&type=style&index=0&id=92cfbc96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92cfbc96",
  null
  
)

export default component.exports